import { render } from "./AddNote.vue?vue&type=template&id=2cb73766&scoped=true"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"

import "./AddNote.vue?vue&type=style&index=0&id=2cb73766&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb73766"]])

export default __exports__